import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ClientsUsersService } from 'src/app/shared/services/other-services/clients-users.service';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import {PageEvent} from "@angular/material/paginator";
@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  public modalRef: BsModalRef;
  userForm: FormGroup;
  clients: any;
  user = '/../../../assets/img/man.svg';
  imageUrl: string;
  reports = [
    "All Clients", "Boda Clusters", "Boda Stages", "Taxi Parks",
    "Taxi Stages", "Boda Stage Clients", "Taxi Stage Clients",
    "Boda Cluster Clients", "Taxi Park Clients", "Boda Stage Chairmen",
    "Taxi Stage Chairmen", "New Clients",
    "Paid Clients", "Savings Clients",
    "Boda Stages Per Cluster", "Taxi Stages Per Park", "BodaBoda Clients",
    "Taxi Clients", "MicroLoan Clients"
  ];
  User = this.authService.loggedInUserInfo();
  singleReport: any;
  reportsCopy: any;
  errored = false;
  totals: any;
  stationName: string;
  locations: any;
  locationId: any;
  level: any;
  areas: any;
  towns: any;
  stations: any;
  select: string;
  p: number;
  total: number;
  customers: any;
  phoneNumbers: any;
  checkedClient: any;
  type: string;
  placeholder: string;
  clusters: any;
  bodaStages: any;
  parks: any;
  taxiStages: any;
  items: any;
  showSelect: boolean;
  locationName = this.User.userLocationName;
  locationVal: number;
  showMe = false;
  selectionKind: number;
  selectionData: any;
  modalTitle: string;
  lowValue: number = 0;
  highValue: number = 10;
  pageSize: number = 10;
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private authService: AuthServiceService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private clientUser: ClientsUsersService,
    private others: OthersService,
  ) {

  }

  ngOnInit(): void {
    this.total = 0;
    this.reports.sort();
    this.getBodaClusters();
    this.getBodaStages();
    this.getTaxiParks();
    this.getTaxiStages();
    this.others.getAllTheStationLocationsByTown(this.User.userLocationId).subscribe(
      res => this.stations = res,
      err => {
        //  //console.log(err)
      }
    );
    this.userForm = this.createFormGroup();
    this.pageSize = 10;
    this.showSelect = false;
  }

  getResult(res: any): void {
    this.checkedClient = res;
    this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }

  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }

  pageSizeOptions() {
    return [5, 10, 20, 30, 40, 50, this.singleReport?.length].filter(n => n <= this.singleReport?.length)
  }

   createFormGroup(): any {
    return this.fb.group({
      report_type: this.fb.control('', Validators.compose([])),
      searchId: this.fb.control('', Validators.compose([])),
      search_by: this.fb.control({value: '', disabled: true}, Validators.compose([])),
      location: this.fb.control({value: '', disabled: true}, Validators.compose([])),
      range_date: this.fb.control({value: '', disabled: true}, Validators.compose([])),
    });
  }
  get fval(): any {
    return this.userForm.controls;
  }
  getBodaClusters(): any {
    this.others.getBodaClusters().subscribe(
      x => {
        this.clusters = x;
        // tslint:disable-next-line: only-arrow-functions
        this.clusters = this.clusters.map(function (cluster: any): any {
          return {
            id: cluster.stageClusterId,
            name: cluster.stageClusterName
          };
        });
      }
    );
  }
  getBodaStages(): any {
    this.others.getBodaStages().subscribe(
      x => {
        this.bodaStages = x;
        // tslint:disable-next-line: only-arrow-functions
        this.bodaStages = this.bodaStages.map(function (stage: any): any {
          return {
            id: stage.bodabodaStageId,
            name: stage.bodabodaStageName
          };
        });
      }
    );
  }
  getTaxiParks(): any {
    this.others.getTaxiParks().subscribe(
      x => {
        this.parks = x;
        // tslint:disable-next-line: only-arrow-functions
        this.parks = this.parks.map(function (park: any): any {
          return {
            id: park.taxiParkId,
            name: park.taxiParkName
          };
        });
      }
    );
  }
  getTaxiStages(): any {
    this.others.getTaxiStages().subscribe(
      x => {
        this.taxiStages = x;
        // tslint:disable-next-line: only-arrow-functions
        this.taxiStages = this.taxiStages.map(function (stage: any): any {
          return {
            id: stage.taxiStageId,
            name: stage.taxiStageName
          };
        });
      }
    );
  }
  changeLevels(val: string): any {
    this.fval.location.reset();
    switch (val) {
      case 'Station':
        this.level = val;
        this.select = `select a ${val}`;
        this.locations = this.stations;
        break;
      case 'General':
        this.level = 'General';
        this.select = `select a ${val}`;
        this.locationName = this.User.userLocationName;
        this.locations = [];
    }
  }

  getReportsCopy() {
    return this.reportsCopy || []
  }

  searchResponse(result: any): any {
    if (result.length) this.singleReport = result;
    else this.singleReport = this.reportsCopy;
    this.total = this.singleReport.length
  }

  changeReport(val: any): any {
    // console.log(val);
    this.singleReport = [];
    this.totals = {};
    this.p = 1;
    this.total = 0;
    this.type = val;
    this.level = 'General';
    this.fval.search_by.setValue('General');
    this.fval.location.reset();
    this.locationName = this.User.userLocationName;
    this.changeLevels('General');
    this.locationVal = null;
    const date = new Date();
    const startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const tx = this.type;
    if (
      tx === "Boda Stage Clients" || tx === "Taxi Stage Clients"
      || tx === "Boda Cluster Clients" || tx === "Taxi Park Clients"
      || tx === "Boda Stages Per Cluster" || tx === "Taxi Stages Per Park"
    ) {
      this.showSelect = true;
      switch (tx) {
        case "Boda Stage Clients":
          this.placeholder = "Select Boda Stage";
          this.items = this.bodaStages;
          this.showMe = false;
          break;
        case "Taxi Stage Clients":
          this.placeholder = "Select Taxi Stage";
          this.items = this.taxiStages;
          this.showMe = false;
          break;
        case "Boda Cluster Clients":
          this.placeholder = "Select Boda Cluster";
          this.items = this.clusters;
          this.showMe = false;
          break;
        case "Boda Stages Per Cluster":
          this.placeholder = "Select Boda Cluster";
          this.items = this.clusters;
          this.showMe = false;
          break;
        case "Taxi Park Clients":
          this.placeholder = "Select Taxi Park";
          this.items = this.parks;
          this.showMe = false;
          break;
        case "Taxi Stages Per Park":
          this.placeholder = "Select Taxi Park";
          this.items = this.parks;
          this.showMe = false;
          break;
      }
    } else {
      this.showSelect = false;
      this.showMe = true;
      this.fetchReports([startDate, endDate], this.type);
    }

    this.fval.search_by.enable();
    this.fval.location.enable();

    if (this.type === 'New Clients') {
      this.fval.range_date.enable()
    } else {
      this.fval.range_date.disable()
    }

    if(this.type === 'Specify Type') {
      this.fval.search_by.disable();
      this.fval.location.disable();
      this.fval.range_date.disable()
    }
  }
  fetchReport(val: any): any {
    let startDate = "";
    let endDate = "";
    const date = new Date();
    if (val.length > 1) {
      startDate = `${val[0].getFullYear()}-${val[0].getMonth() + 1}-${val[0].getDate()}`;
      endDate = `${val[1].getFullYear()}-${val[1].getMonth() + 1}-${val[1].getDate()}`;
      //this.spinner.show;;
      this.fetchReports([startDate, endDate], this.type);
    } else {
      startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      //this.spinner.show;;
      this.fetchReports([startDate, endDate], this.type);
    }
  }
  fetchReports(dates: Array<string>, typeOfReport: string): any {
    this.singleReport = [];
    this.totals = {};
    this.total = 0
    this.locationVal = Number.parseInt(this.userForm.controls.location.value, 10);
    switch (this.level) {
      case 'Station':
        this.stations?.forEach(station => {
          if (station.theStationLocationId === this.locationVal) {
            this.locationName = station.stationName;
          }
        });
        break;
      case 'General':
        this.locationName = this.locationName;
        this.locationVal = Number.parseInt(this.User.userLocationId, 10);
        break;
    }
    const ID = this.fval.searchId.value;
    switch (typeOfReport) {
      case 'All Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getAllClientsByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getAllClientsByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Boda Clusters':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getBodaBodaClustersByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getBodaBodaClustersByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Boda Stages':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getBodaBodaStagesByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getBodaBodaStagesByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Boda Stages Per Cluster':
        this.p = 1;
        this.total = 0;
        this.clientUser.getBodaBodaStagesPerCluster(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Parks':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getTaxiParksByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getTaxiParksByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Taxi Stages':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getTaxiStagesByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getTaxiStagesByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Taxi Stages Per Park':
        this.p = 1;
        this.total = 0;
        this.clientUser.getTaxiStagesPerTaxiPark(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Boda Stage Clients':
        this.p = 1;
        this.total = 0;
        this.clientUser.getCustomersPerBodaBodaStage(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Boda Cluster Clients':
        this.p = 1;
        this.total = 0;
        this.clientUser.getCustomersPerBodaBodaCluster(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Stage Clients':
        this.p = 1;
        this.total = 0;
        this.clientUser.getCustomersPerTaxiStage(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Taxi Park Clients':
        this.p = 1;
        this.total = 0;
        this.clientUser.getCustomersPerTaxiPark(ID).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case 'Boda Stage Chairmen':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getBodaBodaStageChairmenReportByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getBodaBodaStageChairmenReportByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Taxi Stage Chairmen':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getTaxiStageChairmenReportByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getTaxiStageChairmenReportByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'New Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getNewCustomerPerPeriodByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getNewCustomerPerPeriodByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      /* case 'Borrowed Clients':
        this.p = 1;
        this.total = 0;
        if ( this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.clientUser.getWavedPrincimpalByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  this.singleReport = res;
this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                   this.errored = true;
this.alertService.danger({
        html: '<b>' + err + '</b>'
 });
                }
              );
              break;
        case 'Town':
              this.clientUser.getWavedPrincimpalByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  this.singleReport = res;
this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                   this.errored = true;
this.alertService.danger({
        html: '<b>' + err + '</b>'
 });
                }
              );
              break;
        case 'Station':
              this.clientUser.getWavedPrincimpalByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  this.singleReport = res;
this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                   this.errored = true;
this.alertService.danger({
        html: '<b>' + err + '</b>'
 });
                }
              );
              break;
            }
        } else {
          this.clientUser.getNewCustomerPerPeriod({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
              res => {
                this.singleReport = res;
this.reportsCopy = res;
                this.total = this.singleReport.length;
              },
              err => {
                 this.errored = true;
this.alertService.danger({
        html: '<b>' + err + '</b>'
 });
              }
            );
        }
        break; */
      case 'Paid Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getLoanCompletedCustomerByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getLoanCompletedCustomerByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'BodaBoda Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getBodaBodaCustomerByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getBodaBodaCustomerByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Taxi Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getTaxiCustomersByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getTaxiCustomersByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'MicroLoan Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getMicroloanCustomersByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getMicroloanCustomersByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Savings Clients':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'General':
              this.clientUser.getSavingsCustomerByTown(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.clientUser.getSavingsCustomerByStation(this.locationVal).subscribe(
                res => {
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
    }
    this.spinner.hide();
  }
  public openModal(template: TemplateRef<any>, photoUrl?: string): any {
    this.imageUrl = photoUrl;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-dialog-centered' })
    );
  }
  pageChanged(event): any {
    this.p = event;
  }
}
